import ImageContentSection from "../../shared/ReusuableComponent/imagecontentsection/ImageContentSection";
import styles from "./WhoWeAre.module.css";
import Banner from "../../../src/img/staticimages/whyBanner.jpg";


const Vision = "/staticimages/vision.svg";
const Mission = "/staticimages/Mission.svg";
const data = [
  {
    title: "Vision",
    image: Vision,
    description:
      "To be the most trusted and result-oriented Academy in Tamil Nadu, nurturing aspiring youths with knowledge, discipline and integrity, and empowering them to serve society with excellence.",
  },
  {
    title: "Mission",
    image: Mission,
    description: [
      "To provide high-quality and comprehensive coaching for all Competitive examinations through expert faculty and updated study materials.",
      "To build strong academic foundations, analytical skills, and exam strategies among aspirants with dedication and ethical values.",
      "To continuously assess and improve student performance through regular tests, mentoring, and feedback.",
      "To bridge the educational gap for rural and first-generation learners by offering affordable and accessible learning resources.",
      "To empower students from all backgrounds to achieve their dream of entering into Government services.",
    ],
  },
];

const WhoWeAre = () => {
  return (
    <>
      <div>
        <img className={styles.imageSection} src={Banner} alt="images" />
      </div>

      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.heading}>
            We believe education is the key to building a brighter future
          </div>

          <div className={`${styles.paragraph} ${styles.firstParagraph}`}>
            Established in 2010 as ATC Educational Institution, our institution
            has grown into ANNA IAS Academy, continuing our commitment to
            academic excellence and Student success. Since our inception, we
            have helped 10,000+ students to achieve their dream careers in UPSC,
            TNPSC, TNSURB, SSC, Banking, TET, TRB and RRB etc.,
          </div>

          <div className={`${styles.paragraph} ${styles.firstParagraph}`}>
            Our strength lies in our team of experienced faculty members who
            provide subject-wise expertise, concept clarity and strategic
            guidance to every student. We offer well-structured bilingual
            classroom and online courses, comprehensive study materials, regular
            test series, doubt-clearing sessions and regularly tracking student
            performance and providing continuous feedback to help them to
            achieve excellence.
          </div>

          <div className={`${styles.paragraph} ${styles.firstParagraph}`}>
            Talent knows no boundaries. Since, we understand the unique
            challenges faced by rural students, our academy is dedicated to
            guiding aspirants especially from rural backgrounds towards success
            in their journey to become Government Officials.
          </div>

          <div className={styles.tamilText}>
            சொல்வதைச் செய்வோம்! செய்வதைச் சொல்லோம்!
          </div>
        </div>
      </div>
      <ImageContentSection
        items={data}
        imageCol={3}
        contentCol={9}
        imageMaxWidth={410}
      />
    </>
  );
};

export default WhoWeAre;
